var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var PubSub = /** @class */ (function () {
    function PubSub(options) {
        var _this = this;
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: -1
        });
        Object.defineProperty(this, "topics", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "resolveData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var data = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    data[_i] = arguments[_i];
                }
                return data && data.length <= 1 ? data[0] : __spreadArray([], data);
            }
        });
        Object.defineProperty(this, "deliverTopic", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (topic, data) {
                var topics = _this.topics;
                var subscribers = topics[topic] ? __spreadArray([], topics[topic]) : [];
                var len = subscribers.length;
                for (var i = 0; i < len; i += 1) {
                    var token = subscribers[i].token;
                    var currentSubscriber = subscribers[i];
                    if (!_this.options.immediateExceptions) {
                        try {
                            currentSubscriber.callback(data, { name: topic, token: token });
                        }
                        catch (exception) {
                            setTimeout(function () {
                                throw exception;
                            }, 0);
                        }
                    }
                    else {
                        currentSubscriber.callback(data, { name: topic, token: token });
                    }
                    if (currentSubscriber.once === true) {
                        _this.unsubscribe(token);
                    }
                }
            }
        });
        Object.defineProperty(this, "doPublish", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (topic, data, sync) {
                if (!_this.topics[topic]) {
                    return false;
                }
                sync
                    ? _this.deliverTopic(topic, data)
                    : setTimeout(function () {
                        _this.deliverTopic(topic, data);
                    }, 0);
                return true;
            }
        });
        Object.defineProperty(this, "subscribe", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (topic, callback, once) {
                var topics = _this.topics;
                var token = _this.id + 1;
                if (typeof callback !== "function") {
                    throw new TypeError("PubSub subscribe callback must be function");
                }
                if (!topics[topic]) {
                    topics[topic] = [];
                }
                var subscriber = {
                    token: token,
                    callback: callback,
                    once: !!once,
                };
                topics[topic].push(subscriber);
                return token;
            }
        });
        Object.defineProperty(this, "subscribeOnce", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (topic, callback) {
                return _this.subscribe(topic, callback, true);
            }
        });
        Object.defineProperty(this, "publish", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (topic) {
                var data = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    data[_i - 1] = arguments[_i];
                }
                _this.doPublish(topic, _this.resolveData.apply(_this, data), false);
            }
        });
        Object.defineProperty(this, "publishSync", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (topic) {
                var data = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    data[_i - 1] = arguments[_i];
                }
                _this.doPublish(topic, _this.resolveData.apply(_this, data), true);
            }
        });
        Object.defineProperty(this, "unsubscribe", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (tp) {
                var topics = _this.topics;
                var topicFound = false;
                var topicKeys = Object.keys(topics);
                for (var i = 0; i < topicKeys.length; i++) {
                    var prop = topicKeys[i];
                    var subscribers = topics[prop];
                    var len = subscribers.length;
                    while (len) {
                        len = len - 1;
                        // tp 是 topic token
                        if (subscribers[len].token === tp) {
                            subscribers.splice(len, 1);
                            if (subscribers.length === 0) {
                                // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                                delete topics[prop];
                            }
                            return prop;
                        }
                        // tp 是 topic name
                        if (topicKeys[i] === tp) {
                            subscribers.splice(len, 1);
                            if (subscribers.length === 0) {
                                // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                                delete topics[prop];
                            }
                            topicFound = true;
                        }
                    }
                    if (topicFound) {
                        return tp;
                    }
                }
                return false;
            }
        });
        Object.defineProperty(this, "unsubscribeAll", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                _this.topics = {};
                _this.id = -1;
                return _this;
            }
        });
        Object.defineProperty(this, "hasSubscribers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (topic) {
                var topics = _this.topics;
                if (!topic) {
                    if (Object.keys(topics).length > 0) {
                        return true;
                    }
                    return false;
                }
                return Object.prototype.hasOwnProperty.call(topics, topic);
            }
        });
        Object.defineProperty(this, "subscribersByTopic", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (topic) {
                return _this.topics[topic] ? __spreadArray([], _this.topics[topic]) : [];
            }
        });
        Object.defineProperty(this, "subscribers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                var result = {};
                Object.keys(_this.topics).forEach(function (key) {
                    result[key] = __spreadArray([], _this.topics[key]);
                });
                return result;
            }
        });
        var defaults = {
            immediateExceptions: false,
        };
        this.options = __assign(__assign({}, defaults), options);
    }
    Object.defineProperty(PubSub, "createInstance", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: function (options) { return new PubSub(options); }
    });
    return PubSub;
}());
export { PubSub };
